import type * as ApiModels from '@/typings/api-models';

import formatPriceInterval from '../priceInterval';
import formatAmountWithCurrency from '../priceWithCurrency';

/**
 * @deprecated Use `priceWithT.recurring` instead. Note that `t` comes from `const {t} = useTranslation();`
 */
const formatRecurringPrice = (
  price: Pick<ApiModels.Price, 'price' | 'currency' | 'recurringInterval'> | null | undefined,
  discountedPrice?: number,
): string => {
  if (!price) {
    return '';
  }
  const pricePart = formatAmountWithCurrency(discountedPrice || price.price, price.currency);
  const intervalPart = formatPriceInterval(price.recurringInterval);
  return `${pricePart}${intervalPart}`;
};

export default formatRecurringPrice;
